import React, {useEffect, useState} from "react";
import {Modal} from "../../../../../components/modal/modal.jsx";
import Button from "../../../../../components/button/button.jsx";
import InputDatetime from "../../../../../components/input/input-datetime.jsx";
import InputRadio from "../../../../../components/input/input-radio.jsx";
import InputCheckbox from "../../../../../components/input/input-checkbox.jsx";
import projectUtils from "../../../../../utils/project-utils.js";
import {HOUR_TYPES, emptyHours} from "../utils/schedule-garrison-utils.js";

const ScheduleGarrisonHoursModal = ({open, setOpen, value, onSave}) => {
    const [hours, setHours] = useState(emptyHours());

    useEffect(() => {
        if (open) setHours(value ?? emptyHours());
    }, [open, value]);

    const isFixed = hours.type === HOUR_TYPES.FIXED;
    const isInterval = hours.type === HOUR_TYPES.INTERVAL;
    const isWithoutHour = hours.type === HOUR_TYPES.WITHOUT_HOUR;

    const setType = (type) => setHours(prev => ({
        ...prev,
        type,
        startHour: type === HOUR_TYPES.WITHOUT_HOUR ? null : prev.startHour,
        endHour: type === HOUR_TYPES.INTERVAL ? prev.endHour : null,
        startChangeDay: type === HOUR_TYPES.WITHOUT_HOUR ? false : prev.startChangeDay,
        endChangeDay: type === HOUR_TYPES.INTERVAL ? prev.endChangeDay : false,
    }));

    const save = () => {
        if (isInterval) {
            if (!hours.startHour) {
                projectUtils.swalErrorMessage("", "O campo \"Horário inicial\" é obrigatório.", "Ok");
                return;
            }
            if (!hours.endHour) {
                projectUtils.swalErrorMessage("", "O campo \"Horário final\" é obrigatório.", "Ok");
                return;
            }
        }
        onSave(hours);
        setOpen(false);
    };

    return (
        <Modal open={open} setOpen={setOpen} title="Horário" className="w-7/12" overflow={true}>
            <Modal.Body className={"max-h-[calc(100vh-180px)] space-y-4! overflow-auto"}>
                <div className="flex flex-wrap gap-6">
                    <InputRadio id="hour-fixed" name="hourtype" label="Horário fixo" checked={isFixed} onChange={() => setType(HOUR_TYPES.FIXED)}/>
                    <InputRadio id="hour-interval" name="hourtype" label="Intervalo permitido para iniciar a atividade" checked={isInterval} onChange={() => setType(HOUR_TYPES.INTERVAL)}/>
                    <InputRadio id="hour-without" name="hourtype" label="Horário livre" checked={isWithoutHour} onChange={() => setType(HOUR_TYPES.WITHOUT_HOUR)}/>
                    <InputCheckbox
                        id="allowRepeat"
                        label="Permitir repetição da atividade"
                        checked={!!hours.allowRepeat}
                        onChange={({target}) => setHours(prev => ({...prev, allowRepeat: target.checked}))}
                    />
                </div>

                <hr className={"text-[#d9dada]"}/>

                <div className="flex flex-wrap items-center gap-4">
                    <InputDatetime
                        classNameWrapper="w-[160px]"
                        id="startHour"
                        dateFormat="LT"
                        returnDateObj={false}
                        disabled={isWithoutHour}
                        label={isInterval ? "Horário inicial *" : "Horário"}
                        selected={hours.startHour ?? ""}
                        onChange={(value) => setHours(prev => ({...prev, startHour: value ?? ""}))}
                    />
                    <InputCheckbox
                        id="startChangeDay"
                        label="Dia seguinte"
                        disabled={isWithoutHour}
                        checked={!!hours.startChangeDay}
                        onChange={({target}) => setHours(prev => ({...prev, startChangeDay: target.checked}))}
                    />
                    {isInterval &&
                        <>
                            <InputDatetime
                                classNameWrapper="w-[160px]"
                                id="endHour"
                                dateFormat="LT"
                                returnDateObj={false}
                                label="Horário final *"
                                selected={hours.endHour ?? ""}
                                onChange={(value) => setHours(prev => ({...prev, endHour: value ?? ""}))}
                            />
                            <InputCheckbox
                                id="endChangeDay"
                                label="Dia seguinte"
                                checked={!!hours.endChangeDay}
                                onChange={({target}) => setHours(prev => ({...prev, endChangeDay: target.checked}))}
                            />
                        </>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={save} actionFeedbackType='save'>Salvar</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ScheduleGarrisonHoursModal;